<app-page-header title="Időközi választás"></app-page-header>

<div class="content my-3 col-lg-10 mx-auto">
  <ul class="my-3 text-center">
    <li
      *ngFor="let doc of documents"
      (click)="download(doc.name, doc.ext, doc.path)"
    >
      <i
        [ngClass]="
          doc.ext && (doc.ext === '.xls' || doc.ext === '.xlsx')
            ? 'fa-file-excel'
            : doc.ext &&
              (doc.ext === '.odt' || doc.ext === '.doc' || doc.ext === '.docx')
            ? 'fa-file-word'
            : 'fa-file-pdf'
        "
        class="fas mr-3"
      ></i
      >{{ doc.name }}
    </li>
  </ul>
</div>
